export default class BuchungsartInsertRequest {
  id: string
  bestellart: string
}
